import { Dispatch, SetStateAction } from 'react';

import type { CodeConfirmData } from 'app/widgets/CodeConfirmation/types';

import { httpApiService, ResponseStatus } from 'app/api';
import { CodeError } from 'app/widgets/CodeConfirmation/constants';

type reGetCodeProps = {
  reSendData: {
    url: string;
    data: Record<string, string>;
  };
  changeData: Dispatch<SetStateAction<CodeConfirmData>>;
};

export function reGetCode({
  reSendData,
  changeData,
}: reGetCodeProps) {
  httpApiService.post(reSendData.url, reSendData.data)
    .then((res) => {
      changeData((prevState) => ({ ...prevState, ...res.data }));
    })
    .catch(({ response }) => {
      const { serverTime, resendDate, status } = response.data;

      if (status === ResponseStatus.TOO_MANY_REQUESTS) {
        changeData((prevState) => ({ ...prevState, resendDate, serverTime }));
      }
    });
}

// TODO Отрефакторить, WEB-1699
export function getErrorMessage(error: CodeError) {
  switch (error) {
    case CodeError.NOT_CODE:
      return CodeError.NOT_CODE;

    case CodeError.NOT_TOKEN:
      return CodeError.NOT_TOKEN;

    case CodeError.NOT_SEND:
      return CodeError.NOT_SEND;

    case CodeError.SOMETHING_WRONG:
      return CodeError.SOMETHING_WRONG;

    default:
      return CodeError.SOMETHING_WRONG;
  }
}
